import React, { FC, PropsWithChildren } from "react";

import SkeletonBlock from "ui/Skeleton/components/SkeletonBlock/SkeletonBlock";

import styles from "./Wrapper.module.scss";

type Props = PropsWithChildren<{
  title: string;
  isLoading?: boolean;
}>;

const Wrapper: FC<Props> = ({ title, isLoading, children }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {!title && isLoading ? (
          <SkeletonBlock className={styles.titleSkeleton} width="220px" />
        ) : (
          title
        )}
      </div>
      {children}
    </div>
  );
};

export default Wrapper;
